import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import { Dialog } from './index.style';

let tid;

export default function Modal({ children, open, onClose, className = '', openType }) {
  const dialog = useRef();
  const [showCloseBtn, setShowCloseBtn] = useState(true);

  useEffect(() => {
    const modal = dialog.current;
    if (open) {
      modal.showModal();
    }

    return () => modal.close();
  }, [open]);
  useEffect(() => {
    tid = setTimeout(() => {
      if (openType === 'redpacket-rain') {
        setShowCloseBtn(false);
      }
    }, 3000);
    return () => {
      clearTimeout(tid);
    };
  }, [open]);

  const dialogCom = (
    <Dialog
      ref={dialog}
      className={`modal absolute left-0 right-0 bottom-0 top-0 ${className} overflow-visible`}
      onClose={onClose}
    >
      <div id="dialog-inner-message"></div>
      <div id="fixed-bottom-bg"></div>
      {children}
      {showCloseBtn && (
        <button
          onClick={onClose}
          className="absolute z-2 top-[-30px] right-[-40px] size-[32px] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/modal/close-btn.svg)]"
        ></button>
      )}
    </Dialog>
  );

  if (typeof document !== 'undefined') {
    return createPortal(dialogCom, document.getElementById('modal'));
  }
  return dialogCom;
}
